import type { RefObject } from "react";

export function readMountedElement<Element extends HTMLElement>(
  ref: RefObject<Element | null>,
): Element {
  const element = ref.current;

  if (element === null)
    throw new Error("The Cogent interaction is not mounted.");

  return element;
}
